import api from "./api";

export const getTimeBooking = async (queryParam) => {
  return api
    .get({
      endpoint: "/all/hour/open/list",
      port: process.env.REACT_APP_PORT_OPENHOUR,
      queryParam,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
